import * as React from 'react'
import { ApolloConsumer } from 'react-apollo'

import { LoginForm, LoginFormSSO } from 'main/components/common/AuthModal'
import { AppContext } from 'main/framework'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { Text } from 'main/ui'
import { login } from 'main/util/auth'
import { TextContainer } from './Login.styles'

interface IProps {
  onRequestSignUp: () => void
  onComplete: (credentials: CredentialsFields) => void
}

export default function Login(props: IProps) {
  const { onRequestSignUp, onComplete } = props

  const appContext = React.useContext(AppContext)
  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  return (
    <ApolloConsumer>
      {client => {
        if (isSSO) {
          return (
            <div>
              <LoginFormSSO />
            </div>
          )
        } else {
          return (
            <div>
              <TextContainer>
                <Text>Log in to schedule a tour</Text>
              </TextContainer>

              <LoginForm
                cta="Next: Select tour date and time"
                onComplete={credentials => {
                  login(client, credentials, appContext).then(() => onComplete(credentials))
                }}
                onRequestSignUp={onRequestSignUp}
              />
            </div>
          )
        }
      }}
    </ApolloConsumer>
  )
}
